query getPromoBannerSettings {
	promoBannerSettings {
		isActive
		htmlContent
	}
}

